<div class="userActionContainer">
  <motif-icon [iconFunction]="iconoirTrash" strokeWidth="1" title="Remove" class="mr_10" stroke="none" fill="#C70117" size="16"
    (click)="deleteIconHandler()" (keydown.enter)="deleteIconHandler()"></motif-icon>
  <motif-icon [iconFunction]="iconoirFloppyDisk" title="Save" strokeWidth="1" stroke="none"
    [attr.fill]="saveDisabled ? '#BBBBBB' : '#656579'"
    [style.opacity]="saveDisabled ? '0.4' : '1'"
    [style.pointer-events]="saveDisabled ? 'none' : 'auto'"
    [style.cursor]="saveDisabled ? 'default' : 'pointer'"
    size="16" (click)="saveIconHandler()" (keydown.enter)="saveIconHandler()"></motif-icon>
</div>